module.exports = __webpack_public_path__ + "img/light-Path 25@3x.ef92bbce.png";